import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { getVariantUrl, getVarsoUrl } from "../../../../common/helpers/helpers";
import { getGenomeName } from "../../../../state/selectors/general.selectors";
import {
  getNcbiDbnsfpSchemaProperties,
  getNcbiDbnsfpData,
  getVcfRsIds,
} from "../../../../state/selectors/VariantDetails.selectors";
import ConditionalLink from "../../../../components/atoms/ConditionalLink/ConditonalLink";
import HelperText from "../../../../components/atoms/HelperText";

const { arrayOf, shape, number, string } = PropTypes;

const DbnsfpRsIds = ({ ncbiDbnsfp, schemaProps, genomeName, vcfRsIds }) => {
  if (ncbiDbnsfp) {
    // If the query was a VCF query and there were rsId(s) contained in the query's descriptor field,
    // check if they are contained in the results rsIds, otherwise display a warning
    let vcfRsIdsWarning;
    let vcfRsIdsWarningText;
    if (typeof vcfRsIds !== "undefined" && vcfRsIds.length) {
      let vcfRsIdsFound = 0;
      for (let i = 0; i < vcfRsIds.length; i++) {
        const vcfRsId = vcfRsIds[i];
        for (let j = ncbiDbnsfp[0].rsid.length - 1; j >= 0; j--) {
          if (`rs${ncbiDbnsfp[0].rsid[j]}` === vcfRsId) {
            vcfRsIdsFound += 1;
            break;
          }
        }
      }
      if (vcfRsIdsFound !== vcfRsIds.length) {
        vcfRsIdsWarning = true;
        vcfRsIdsWarningText = `The RsID ${
          vcfRsIds.length > 1 ? "s" : ""
        } in your query ${
          vcfRsIds.length > 1 ? "do" : "does"
        } not<br /> match the result's RsID ${
          ncbiDbnsfp[0].rsid.length > 1 ? "s" : ""
        }`;
      }
    }

    return (
      <div className="varsome-horiz-list-item">
        <div className="varsome-horiz-list-label">
          {schemaProps.items.properties.rsid.label}
          <HelperText fieldDescriptionKey="Rsid" />
          {vcfRsIdsWarning && (
            <i
              className="fa fa-exclamation-circle"
              data-tooltip={vcfRsIdsWarningText}
              data-tooltip-dangerous-html={true}
              style={{ marginLeft: "0.3rem", color: "red" }}
            />
          )}
        </div>
        {ncbiDbnsfp[0].rsid.map((item, i) => {
          const url = getVariantUrl(genomeName, `rs${item}`, null, true);
          const ncbiUrl = `http://www.ncbi.nlm.nih.gov/snp/?term=rs`;
          return (
            <div className="varsome-horiz-list-value" key={i}>
              <ConditionalLink href={url} text={`rs${item}`} />
              <span className="tw-my-0 tw-mx-1">|</span>
              <small>
                <a href={getVarsoUrl(`${ncbiUrl}${item}`)} target="_blank">
                  <i className="fa fa-external-link" />
                  {" dbSNP"}
                </a>
              </small>
            </div>
          );
        })}
      </div>
    );
  }

  return null;
};

DbnsfpRsIds.propTypes = {
  ncbiDbnsfp: arrayOf(
    shape({
      rsid: arrayOf(number),
      version: string,
    })
  ),
  schemaProps: shape({}),
  genomeName: string,
  vcfRsIds: arrayOf(string),
};

DbnsfpRsIds.defaultProps = {
  ncbiDbnsfp: null,
  schemaProps: null,
  genomeName: null,
  vcfRsIds: [],
};

const mapStateToProps = (state) => ({
  ncbiDbnsfp: getNcbiDbnsfpData(state),
  schemaProps: getNcbiDbnsfpSchemaProperties(state),
  genomeName: getGenomeName(state),
  vcfRsIds: getVcfRsIds(state),
});

export default connect(mapStateToProps)(DbnsfpRsIds);
